import type { OperationalClock, Workspace } from './model'
import { localDate } from './time'

/** Demo time is anchored once on activation; wall time never silently rolls the demo forward. */
export function createOperationalClock(anchor?: string): OperationalClock {
  if (anchor && !Number.isFinite(Date.parse(anchor))) throw new Error('Invalid operational clock anchor.')
  return { now: () => anchor ?? new Date().toISOString(), today: (timeZone = 'Europe/Helsinki') => localDate(anchor ?? new Date().toISOString(), timeZone) }
}
export function workspaceClock(workspace: Workspace): OperationalClock { return createOperationalClock(workspace.demoClockAt) }
